/**
 * Language resource for text content related to user management.
 * @typedef {Object} UserManagementTextContent
 * @property {string} name - Label for the name field.
 * @property {string} email - Label for the email field.
 * @property {string} phone - Label for the phone field.
 * @property {string} country - Label for the country field.
 * @property {string} age - Label for the age field.
 * @property {string} gender - Label for the gender field.
 * @property {string} language - Label for the preferred language field.
 * @property {string} type - Label for the plan type field.
 * @property {string} created - Label for the created on field.
 * @property {string} title - Title for the Users section.
 * @property {string} subscriberType - Label for the subscriber type field.
 * @property {string} additional - Label for the additional field.
 * @property {string} notificationMessage - Label for the notification message field.
 * @property {string} userManageTitle - Title for the User Management section.
 * @property {string} youWantToActive - Confirmation message for activating a user.
 * @property {string} youWantToDeActive - Confirmation message for deactivating a user.
 * @property {string} userManagement - Label for the User Management section.
 * @property {string} userDetails - Label for the User Details section.
 * @property {string} planExpiryDate - Label for the plan expiry date field.
 * @property {string} planStartDate - Label for the plan start date field.
 * @property {string} shortDetails - Label for the short details section.
 * @property {string} searchByUser - Placeholder text for the search by user field.
 * @property {string} amount - Label for the amount field.
 */

/**
 * Language resource for text content related to user management.
 * @type {UserManagementTextContent}
 */
export const text = {
  name: 'Name',
  email: 'Email',
  phone: 'Phone',
  country: 'Country',
  age: 'Age',
  gender: 'Gender',
  language: 'Preferred Language',
  type: 'Plan Type',
  created: 'Created On',
  title: 'Users',
  subscriberType: 'Subscriber Type',
  additional: 'Additional',
  notificationMessage: 'Notification Message',
  userManageTitle: 'User Management',
  youWantToActive: 'you want to activate this user?',
  youWantToDeActive: 'you want to deactivate this user?',
  userManagement: 'User Management',
  userDetails: 'User Details',
  planExpiryDate: 'Plan Expiry Date',
  planStartDate: 'Plan Start Date',
  freeFlag: 'Free Flag',
  shortDetails: 'Short Details',
  searchByUser: 'First Name and Last Name Email, Phone Number.',
  amount : 'Amount',
}
